import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActionCreator } from '../../store/actions/modalActions';
import { Card, Button, Form, Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { IncomingMessageService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheck, faPen, faChevronCircleRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

class IncomingMessage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { message: {attachments: []}, statusRefData: [], firstCall: true};

        //this.createNewCustomer = this.createNewCustomer.bind(this);
        //this.filterSort = this.filterSort.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
        this.saveMessage = this.saveMessage.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.return = this.return.bind(this);
    }

    componentDidMount() {
        this.getMessages();
    }

    async getMessages() {
        if (this.props.match.params.id !== undefined) {
            var msgId = this.props.match.params.id;
            var messageService = new IncomingMessageService();
            let filter = { messageId: msgId, firstCall: this.state.firstCall, currentPage: 0, pageSize: 1 };
            var callResult = await messageService.getIncomingMessages(filter);

            let statusRefData = callResult.model.statusRefData.slice(1);

            this.setState({ message: callResult.model.messages[0], statusRefData: statusRefData, firstCall: false });
        }
    }

    return() {
        this.props.history.push('/coding/messages');
    }

    updateStatus(event) {
        let message = { ...this.state.message };
        const target = event.target;
        const name = target.name;
        const value = parseInt(target.value);
        message[name] = value;
        this.setState({ message: message });
    }

    async saveMessage() {
        var messageService = new IncomingMessageService();
        var callResult = await messageService.updateIncomingMessage(this.state.message);
        if (callResult.result) {

        }
        //if (callResult.result) {
        //    this.setState({ message: callResult.model });
        //};
    }

    async downloadFile(id, contentType, fileName) {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        var service = new IncomingMessageService();
        var response = await service.getIncomingMessageAttachment(this.state.message.id, id);

        if (response.result) {
            var blob = new Blob([response.model], { type: contentType });
            var link = document.createElement("a");
            link.setAttribute("href", response.model);
            //link.setAttribute("download", "test.jpg");
            link.style.display = "none";
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
        }

    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto">Messages</div>
                    <div className="card-btn-group">
                        <Button variant="secondary" size="sm" onClick={() => this.return()}>Close</Button>
                        <Button variant="success" size="sm" onClick={() => this.saveMessage()}>Save</Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form.Group as={Row} controlId="from">
                        <Form.Label column sm="2">
                            Status
                        </Form.Label>
                        <Col sm="6">
                            <Form.Control as="select" value={this.state.message.status} name="status" id="status" onChange={this.updateStatus}>

                                {
                                    this.state.statusRefData.map((status) => {
                                        return <option key={status.id} value={status.id}>{status.id === this.state.message.status? "Status: " + status.name : status.name}</option>
                                    })
                                }
                            </Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="from">
                        <Form.Label column sm="2">
                            From
                        </Form.Label>
                        <Col sm="10">
                            {this.state.message.emailFrom}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="subject">
                        <Form.Label column sm="2">
                            Subject
                        </Form.Label>
                        <Col sm="10">{this.state.message.subject}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="body">
                        <Form.Label column sm="2">
                            Body
                        </Form.Label>
                        <Col sm="10" style={{ whiteSpace: "pre-line" }}>{this.state.message.body}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="Attachments">
                        <Form.Label column sm="2">
                            Attachments
                        </Form.Label>
                        <Col sm="6">
                            {
                                this.state.message.attachments.map((att, i) => {
                                    return <Row>
                                        <Col lg={4} md={10}>
                                            {att.fileName}
                                        </Col>
                                        <Col lg={1}>
                                            <FontAwesomeIcon icon={faDownload} onClick={() => this.downloadFile(att.id, att.contentType, att.fileName)} className="secondary-icon givemethefinger" />
                                        </Col>
                                    </Row>
                                    })
                            }
                        </Col>
                    </Form.Group>
                </Card.Body>
                </Card>
            );
    }

}

export default IncomingMessage;
//export default connect(null, dispatch => bindActionCreators(modalActionCreator, dispatch))(Customers);